module.exports = __webpack_public_path__ + "08613d6b2915e1c281980b0f15dc7294.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/home-banner/banner.png
// module id = ./assets/images/home-banner/banner.png
// module chunks = 0